import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { ApiResponse } from '@/types/addContainerBlExportType';
import Endpoints from '@/enums/Endpoints';

type CambiarEstadoPagaRequest = {
  oidLiquidacion: number;
};

export const cambiarEstadoPaga = async (
  query: CambiarEstadoPagaRequest
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.CambiarEstadoPaga,
      query
    );

    if (res?.data?.value?.ok === false) {
      throw new Error(res?.data?.value?.mensaje);
    }

    if (res?.data?.value?.error) {
      throw new Error(res?.data?.value?.error);
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
